import { isVelvetLabToken } from "../utils/brandLogo";

/** Legacy user ID for JU prod custom My Cases UI. Prefer token (JU). */
export const CUSTOM_CASE_VIEW_USER_IDS: number[] = [118];

/**
 * Custom My Cases statuses/colours for JU labs only.
 */
export const hasCustomCaseView = (
  userId?: number,
  token?: string | null
): boolean =>
  isVelvetLabToken(token) ||
  (userId != null && CUSTOM_CASE_VIEW_USER_IDS.includes(userId));
